export default __webpack_public_path__ + "4edd2ca7ccfedea9f0a1fb55c8ad6991.woff";